module.exports = __webpack_public_path__ + "img/turen.1d2d2d88.jpg";